// extracted by mini-css-extract-plugin
export var buttons = "_bc-0";
export var buttonsActive = "_bc-h";
export var cancelConfirm = "_bc-1";
export var closeButton = "_bc-2";
export var column = "_bc-3";
export var container = "_bc-4";
export var detailHeader = "_bc-6";
export var detailTitle = "_bc-7";
export var detailsContent = "_bc-5";
export var header = "_bc-8";
export var headerWithClose = "_bc-9";
export var icon = "_bc-a";
export var infoIcon = "_bc-c";
export var informationContainer = "_bc-b";
export var sideDrawer = "_bc-d";
export var sideDrawerOpen = "_bc-e";
export var stickyFooter = "_bc-f";
export var typeOption = "_bc-g";